export default __webpack_public_path__ + "static/media/medline-logo.808f570b.svg";